import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Cancel16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_287)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 0.25C3.71979 0.25 0.25 3.71979 0.25 8C0.25 12.2802 3.71979 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25ZM1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C9.4556 1.75 10.795 2.2476 11.8573 3.08197L3.08197 11.8573C2.2476 10.795 1.75 9.4556 1.75 8ZM4.14263 12.918C5.20497 13.7524 6.54437 14.25 8 14.25C11.4518 14.25 14.25 11.4518 14.25 8C14.25 6.54437 13.7524 5.20497 12.918 4.14263L4.14263 12.918Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_287'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Cancel16.displayName = 'Cancel16';
export default Cancel16;
